import templateUrl from './select-dropdown.html';

export const selectDropdownComponent = {
    bindings: {
        options: '<',
        title: '@',
        placeholder: '@',
        isRequired: '@',
        defaultSelectedId: '@',
        onChange: '&',
        arrowColor: '@'
    },

    templateUrl,

    controller: class SelectDropdownComponent {
        constructor($parse) {
            'ngInject';

            this.$parse = $parse;
        }

        $onInit() {
            this.optionId = this.defaultSelectedId || null;
            this._isRequired = this.$parse(this.isRequired || 'true')(true);
            this.arrowColor = this.arrowColor || "green";
        }

        _onChange() {
            this.onChange({
                $event: this.optionId
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/select-dropdown/select-dropdown.component.js